function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.05 11.05a1 1 0 0 0 0 1.414L14.586 16l-3.536 3.536a1 1 0 0 0 1.414 1.414L16 17.414l3.535 3.536a1 1 0 0 0 1.415-1.414L17.414 16l3.536-3.536a1 1 0 1 0-1.415-1.414L16 14.586l-3.536-3.536a1 1 0 0 0-1.414 0z"
});

var SvgXmarkSmall = function SvgXmarkSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "5fb6529da8b04c8b9081348f8bf43249.svg";
export { SvgXmarkSmall as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/xmark-small.svg
// module id = null
// module chunks = 